import { createOperation } from "../operations";

export const initializeGoogleTagManagerOperation = createOperation<void>("ANALYTICS/INITIALIZE_GOOGLE_TAG_MANAGER");
